import sdl from '@jds/react-generated-sdl/JDSAvatar';
import type { JDSAvatarProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, AvatarProps } from '../logic';

const Component = (props: AvatarProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    size = 'medium',
    kind = 'icon',
    disabled = false,
    isClickable = false,
    ariaLabel = 'avatar',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { size, kind, disabled, isClickable, ariaLabel, ...rest },
    'JDSAvatar',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Avatar = withLogic(Component) as React.FC<AvatarProps> & {
  slotName?: string;
};

Avatar.displayName = 'Avatar';
Avatar.slotName = 'jds_avatar';

export { Avatar, type JDSAvatarProps };
